import { apiGet } from './client';

// Workbench MVP Session A — Architecture Explorer.
// Node ids must match `lib/architectureTopology.ts`; a node that doesn't appear
// there won't render on the diagram, and a node in the diagram that isn't in
// this response renders as "no data".

export type ArchitectureNodeStatus = 'healthy' | 'degraded' | 'idle';

export interface ArchitectureNodeStat {
  nodeId: string;
  invocationCount: number;
  avgLatencyMs: number | null;
  p95LatencyMs: number | null;
  errorCount: number;
  slaBreachCount: number;
  status: ArchitectureNodeStatus;
}

export interface ArchitectureSummary {
  windowDays: number;
  windowStart: string;
  windowEnd: string;
  totalTraceCount: number;
  totalStepCount: number;
  totalErrorCount: number;
  nodeStats: ArchitectureNodeStat[];
  generatedAt: string;
}

export const getArchitectureSummary = (windowDays = 7) =>
  apiGet<ArchitectureSummary>(`/api/architecture/summary?windowDays=${windowDays}`);
